var map = {
	"./sale-badge-1.png": "482b",
	"./sale-badge-2.png": "1b48",
	"./sale-badge-3.png": "2e6d",
	"./sale-badge-4.png": "fcf1",
	"./sale-badge-5.png": "2270",
	"./sale-badge-6.png": "f565"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "59f2";